import { useParams } from 'react-router-dom';

import { BASENAME } from '../../constants/basenames';

/**
 * Hook that returns the `basename` of the current view.
 *
 * @returns {BASENAME}
 */
const useBasename = () => {
  const { basename } = useParams();

  // Default to Shutterbug for components using this outside of PRO.
  // Once PRO & other apps are merged, we may not need this anymore.
  return basename ?? BASENAME.SHUTTERBUG;
};

export default useBasename;
